import { call, put, takeEvery } from "redux-saga/effects";

import {
  CONTACTS_LIST,
  CONTACTS_FULLLIST,
  CONTACTS_FILTER,
  CONTACTS_CREATE,
  CONTACTS_CREATE_LOGIN,
  CONTACTS_UPDATE,
  CONTACTS_DELETE
} from "./actionTypes";

import {
 contactsListSuccess,
 contactsFuLLListSuccess,
 contactsCreateSuccess,
 contactsCreateLoginSuccess,
 contactsUpdateSuccess,
 contactsDeleteSuccess,
 contactsRequestFailed,
} from "./actions";

import {
  getContactsList,
  getContactsFullList,
  getContactsFilter,
  postContactsCreate,
  postContactsCreateSinLogin,
  patchContactsUpdate,
  deleteContacts,
} from "../../helpers/backend";

function*contactsListSaga() {
  console.log("Trayendo lista de contacts...");
  try {
    const response = yield call(getContactsList);
    if (response.status === 200) {
      yield put(contactsListSuccess(response.data));
      console.log(response.response)
    } else {
      yield put(contactsRequestFailed(response.data));
      console.log(response.response)
    }
  } catch (error) {
    yield put(contactsRequestFailed(error.response.data));
    console.log(error.response)
  }
}
function*contactsFuLllistSaga() {
  console.log("Trayendo lista de FullList...");
  try {
    const response = yield call(getContactsFullList);
    if (response.status === 200) {
      yield put(contactsFuLLListSuccess(response.data));
     
    } else {
      yield put(contactsRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(contactsRequestFailed(error.response.data));
  }
}

function*contactsCreateSaga({ payload:contacts }) {
  console.log("Creando nuevo contacts...");
  try {
    const response = yield call(postContactsCreate,contacts);
    if (response.status === 201) {
      yield put(contactsCreateSuccess(response.data));
    } else {
      yield put(contactsRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(contactsRequestFailed(error.response.data));
  }
}
function*contactsCreateLoginSaga({ payload:contacts }) {
  console.log("Creando nuevo contacts...");
  try {
    const response = yield call(postContactsCreateSinLogin,contacts);
    if (response.status === 201) {
      yield put(contactsCreateLoginSuccess(response.data));
    } else {
      yield put(contactsRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(contactsRequestFailed(error.response.data));
  }
}

function*contactsFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getContactsFilter, { changeUrl });
    if (response.status === 200) {
      yield put(contactsListSuccess(response.data));
    } else {
      yield put(contactsRequestFailed(response.data));
    }
  } catch (error) {
    yield put(contactsRequestFailed(error.response.data));
  }
}

function*contactsUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos del CONTACTS...");
  try {
    const response = yield call(patchContactsUpdate, { id }, data);
    if (response.status === 200) {
      yield put(contactsUpdateSuccess(response.data));
    } else {
      yield put(contactsRequestFailed(response.data));
    }
  } catch (error) {
    yield put(contactsRequestFailed(error.response.data));
  }
}

function*contactsDeleteSaga({ payload: { id } }) {
  console.log("Borrando dantos del contacto...");
  try {
    const response = yield call(deleteContacts, id );
    if (response.status === 204) {
      yield put(contactsDeleteSuccess(response));
      console.log(response)
    } else {
      yield put(contactsRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(contactsRequestFailed(error.response.data));
  }
}

export default function*contactsSaga() {
  yield takeEvery(CONTACTS_LIST,contactsListSaga);
  yield takeEvery(CONTACTS_FILTER,contactsFilterSaga);
  yield takeEvery(CONTACTS_CREATE,contactsCreateSaga);
  yield takeEvery(CONTACTS_CREATE_LOGIN,contactsCreateLoginSaga);
  yield takeEvery(CONTACTS_UPDATE,contactsUpdateSaga);
  yield takeEvery(CONTACTS_DELETE,contactsDeleteSaga);
  yield takeEvery(CONTACTS_FULLLIST,contactsFuLllistSaga);
}
